import React, {useContext, useEffect, useMemo, useState, memo} from "../../__snowpack__/pkg/react.js";
import {message, Modal, Tooltip, Upload} from "../../__snowpack__/pkg/antd.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {isEmpty} from "../../__snowpack__/pkg/lodash.js";
import {IconPlus} from "../../__snowpack__/pkg/@genieui-react/icon.js";
import {checkImageRatio, checkVideoWH} from "./uploaderUtils.js";
import LocaleContext from "../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import {SessionHelper} from "../../__snowpack__/pkg/@genie/lib-iam-utils.js";
import {PlayCircleOutlined, DeleteOutlined} from "../../__snowpack__/pkg/@ant-design/icons.js";
const i18n = {
  "zh-cn": {
    invalidSizeMsg: "\u56FE\u7247\u5FC5\u987B\u662FJPG\u3001PNG\u683C\u5F0F\uFF0C\u6700\u59274MB",
    invalidWhMsg: "\u5206\u8FA8\u7387\uFF1A300*300px\uFF5E1024*1024px",
    invalidRatioMsg: "\u53EA\u652F\u63011:1\u7684\u56FE\u7247"
  },
  en: {
    invalidSizeMsg: "Image must be JPG, PNG format, max. 4MB",
    invalidWhMsg: "Resolution: 300*300px\uFF5E1024*1024px",
    invalidRatioMsg: "Only supports 1:1 images"
  },
  id: {
    invalidSizeMsg: "Gambar harus dalam format JPG, PNG, maks. 4MB",
    invalidWhMsg: "Resolusi: 300*300px\uFF5E1024*1024px",
    invalidRatioMsg: "Hany bisa gambar dengan perbandingan 1:1"
  },
  vi: {
    invalidSizeMsg: "H\xECnh \u1EA3nh b\u1EAFt bu\u1ED9c l\xE0 \u0111\u1ECBnh d\u1EA1ng JPG, PNG, t\u1ED1i \u0111a 4MB",
    invalidWhMsg: "\u0110\u1ED9 ph\xE2n gi\u1EA3i: 300 * 300px \uFF5E 1024 * 1024px",
    invalidRatioMsg: "Ch\u1EC9 h\u1ED7 tr\u1EE3 h\xECnh \u1EA3nh 1: 1"
  },
  th: {
    invalidSizeMsg: "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A JOG, PNG, \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 4MB",
    invalidWhMsg: "\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14: 300*300px\uFF5E1024*1024px	",
    invalidRatioMsg: "\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E02\u0E19\u0E32\u0E14\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E40\u0E1B\u0E47\u0E19 1:1"
  }
};
const VideoUpload = memo((props) => {
  const {locale} = useContext(LocaleContext);
  const [state, setStateRaw] = useState({
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: []
  });
  const [newFileList, setNewFileList] = useState([]);
  const setState = (state2) => {
    props.onChange && props.onChange(state2.fileList);
    setNewFileList(state2.fileList);
    setStateRaw(state2);
  };
  const getNewFileList = useMemo(() => {
    return newFileList?.filter((_) => _.status === "done")?.map((data) => {
      return data?.response?.fileUrl;
    });
  }, [newFileList]);
  const curRequiredLabel = useMemo(() => {
    if (!isEmpty(props.requiredLabel) && typeof props.requiredLabel === "string") {
      return props.requiredLabel;
    }
    if (typeof props.requiredLabel === "function") {
      return props.requiredLabel(state.fileList.length);
    }
  }, [props.requiredLabel, state.fileList]);
  const handleCancel = () => {
    setState({...state, previewVisible: false});
  };
  const handlePreview = async (file) => {
    setState({
      ...state,
      previewImage: file.response?.fileUrl || file.url || file.thumbUrl,
      previewVisible: true,
      previewTitle: file.name || file.uid || (file.url || "").substring((file.url || "").lastIndexOf("/") + 1)
    });
  };
  const handleChange = ({file, fileList: fileList2}) => {
    setState({
      ...state,
      fileList: fileList2.filter((_) => _.status)
    });
  };
  useEffect(() => {
    setStateRaw({
      ...state,
      fileList: [...props.value || []]
    });
  }, [props.value]);
  const {previewVisible, previewImage, fileList, previewTitle} = state;
  const uploadButton = /* @__PURE__ */ React.createElement("div", {
    className: "uploader-button",
    id: !curRequiredLabel ? props.id : void 0
  }, /* @__PURE__ */ React.createElement(IconPlus, {
    primaryColor: "#7F8FA4",
    style: {display: "block", width: 21, height: 21}
  }), curRequiredLabel && /* @__PURE__ */ React.createElement(Tooltip, {
    title: curRequiredLabel,
    placement: "topLeft"
  }, /* @__PURE__ */ React.createElement("div", {
    id: props.id,
    className: "upload-button-title"
  }, curRequiredLabel)));
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "uploader"
  }, /* @__PURE__ */ React.createElement(Upload, {
    accept: "video/*",
    headers: {Authorization: SessionHelper.getSessionToken() ?? ""},
    disabled: props.disabled,
    name: "file",
    action: "/saas/product/v2/upload/upload-file",
    listType: "picture-card",
    fileList,
    itemRender: (node, file, fileList2) => {
      if (file.status === "done") {
        return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
          className: "uploader-item-video-box"
        }, /* @__PURE__ */ React.createElement("div", {
          className: "uploader-item-video-icon"
        }, /* @__PURE__ */ React.createElement(PlayCircleOutlined, {
          onClick: () => {
            handlePreview(file);
          },
          style: {fontSize: 16, color: "#fff", cursor: "pointer", marginRight: 12}
        }), /* @__PURE__ */ React.createElement(DeleteOutlined, {
          onClick: () => {
            handlePreview(file);
            setState({
              ...state,
              fileList: state.fileList.filter((_) => _.uid !== file.uid)
            });
          },
          style: {fontSize: 16, color: "#fff", cursor: "pointer"}
        })), /* @__PURE__ */ React.createElement("video", {
          src: file.response?.fileUrl || file.url || file.thumbUrl,
          className: "uploader-item-video"
        })));
      }
      return /* @__PURE__ */ React.createElement("div", {
        className: "uploader-item"
      }, node);
    },
    beforeUpload: async (file) => {
      if (props.limitWH) {
        try {
          await checkVideoWH(file, props.limitWH[0], props.limitWH[1]);
        } catch (error) {
          message.error(props.invalidWhMsg || i18n[locale].invalidWhMsg);
          return Promise.reject("Invalid WH");
        }
      }
      if (props.limitMaxWH) {
        try {
          await checkVideoWH(file, props.limitMaxWH[0], props.limitMaxWH[1], true);
        } catch (error) {
          message.error(props.invalidWhMsg || i18n[locale].invalidWhMsg);
          return Promise.reject("Invalid WH");
        }
      }
      if (props.limitRatio) {
        try {
          await checkImageRatio(file, props.limitRatio);
        } catch (error) {
          message.error(props.invalidRatioMsg || i18n[locale].invalidRatioMsg);
          return Promise.reject("Invalid WH");
        }
      }
      if (props.limitSizeM) {
        if (file.size / 1024 / 1024 > props.limitSizeM) {
          message.error(props.invalidSizeMsg || i18n[locale].invalidSizeMsg);
          return Promise.reject("Invalid Size");
        }
      }
      return Promise.resolve(file);
    },
    onPreview: handlePreview,
    onChange: (files) => {
      let cvFiles = {...files};
      cvFiles.file = {
        ...cvFiles.file,
        response: cvFiles.file.response?.data || cvFiles.file.response
      };
      cvFiles.fileList = cvFiles.fileList?.map((data) => {
        return {
          ...data,
          response: data?.response?.data || data?.response
        };
      });
      handleChange(cvFiles);
    },
    maxCount: props.limitNum,
    ...props.uploadProps
  }, fileList.length >= (props.limitNum || 1) ? null : uploadButton), /* @__PURE__ */ React.createElement(VideoModal, {
    destroyOnClose: true,
    visible: previewVisible,
    title: previewTitle,
    footer: null,
    width: props.modalWidth || 800,
    onCancel: handleCancel,
    className: "uploader-item-video-modal"
  }, /* @__PURE__ */ React.createElement("video", {
    autoPlay: true,
    controls: true,
    src: previewImage,
    className: "uploader-item-show"
  })));
});
export default VideoUpload;
const Wrapper = styled.div`
  &.uploader {
  }
  .uploader-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .upload-button-title {
      position: absolute;
      width: 100px;
      left: 0;
      bottom: -22px;
      font-size: 12px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: #7f8fa4;
      line-height: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .uploader-item-video {
    position: relative;
    width: 100px;
    height: 100px;
    background: #fafdff;
    border: 1px dashed #7f8fa4;
  }
  .uploader-item-video-box {
    position: relative;
    border-radius: 4px;
    width: 100px;
    height: 100px;
    overflow: hidden;
    .uploader-item-video-icon {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      justify-content: center;
      align-items: center;
      z-index: 1;
      display: none;
    }
    :hover {
      .uploader-item-video-icon {
        display: flex;
      }
    }
  }

  .uploader-item {
    width: 100px;
    height: auto;
  }
  .upload-item-title {
    display: block;
    text-align: center;
    margin-top: 8px;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ant-upload-list-picture-card-container {
    width: 100px;
    height: auto;
    margin-right: 12px;
  }
  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 100px;
    height: 100px;
  }
  .ant-upload.ant-upload-select-picture-card {
    position: relative;
    width: 100px;
    height: 100px;
    background: #fafdff;
    border-radius: 4px;
    border: 1px dashed #7f8fa4;
    margin-bottom: 30px;
  }
`;
const VideoModal = styled(Modal)`
  .ant-modal-body {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #333;
  }
  .uploader-item-show {
    height: 400px;
  }
`;
